import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "options-list-input" }
const _hoisted_2 = { class: "options-list-input__text" }
const _hoisted_3 = { class: "options-list-input__options" }
const _hoisted_4 = ["name", "value"]
const _hoisted_5 = { class: "options-list-input__label" }
const _hoisted_6 = { class: "options-list-input__label-text" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, _toDisplayString(_ctx.label), 1 /* TEXT */),
    _cache[4] || (_cache[4] = _createTextVNode()),
    _createElementVNode("section", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("label", {
          class: _normalizeClass(["options-list-input__option", `options-list-input__option--${option.value}`]),
          key: option.value
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "options-list-input__input",
            name: _ctx.name,
            value: option.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValues) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4), [
            [_vModelCheckbox, _ctx.selectedValues]
          ]),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createCommentVNode(" :type=\"multiple ? 'checkbox' : 'radio'\"  /// see todo"),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("span", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {
              option: option,
              selected: _ctx.isSelected(option)
            }, () => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(option.label), 1 /* TEXT */)
            ])
          ])
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createVNode(_Transition, { name: "input-error--animation" }, {
      default: _withCtx(() => [
        (!!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "options-list-input__error | input-error",
              innerHTML: _ctx.error
            }, null, 8 /* PROPS */, _hoisted_7))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}